import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { SystemSection } from '../components/sales/SystemSection';
import { TransformationSection } from '../components/sales/TransformationSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { UrgencySection } from '../components/sales/UrgencySection';
import { PricingSection } from '../components/sales/PricingSection';
import { FAQSection } from '../components/sales/FAQSection';
import { FinalCTA } from '../components/sales/FinalCTA';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#F97316] selection:text-white" data-id="element-205">
      <main data-id="element-206">
        <HeroSection data-id="element-207" />
        <ProblemSection data-id="element-208" />
        <SolutionSection data-id="element-209" />
        <SystemSection data-id="element-210" />
        <TransformationSection data-id="element-211" />
        <TestimonialsSection data-id="element-212" />
        <UrgencySection data-id="element-213" />
        <PricingSection data-id="element-214" />
        <FAQSection data-id="element-215" />
        <FinalCTA data-id="element-216" />
      </main>

      <Footer data-id="element-217" />
    </div>;
}